module.exports = __webpack_public_path__ + "img/complyon-white.2c0501f0.png";